module.exports = __webpack_public_path__ + "static/img/sub-001.6c614c0.png";


//////////////////
// WEBPACK FOOTER
// ./static/sub-001.png
// module id = /Xfv
// module chunks = 1